import { render, staticRenderFns } from "./PredefinedStatusesList.vue?vue&type=template&id=d615b492&scoped=true"
import script from "./PredefinedStatusesList.vue?vue&type=script&lang=js"
export * from "./PredefinedStatusesList.vue?vue&type=script&lang=js"
import style0 from "./PredefinedStatusesList.vue?vue&type=style&index=0&id=d615b492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d615b492",
  null
  
)

export default component.exports